/**
 * Legacy sample rows used "Name (TTR seed)" in DB seeds. Strip for display/export
 * (migration 146 removes persisted values; this covers stale caches or old DBs).
 */
export function stripTtrSeedDemoSuffix(name) {
  if (name == null || name === '') return null
  const s = String(name).replace(/\s*\(TTR seed\)\s*$/i, '').trim()
  return s || null
}
